import { render, staticRenderFns } from "./ModalMoveToFolder.vue?vue&type=template&id=f950c770&"
import script from "./ModalMoveToFolder.vue?vue&type=script&lang=js&"
export * from "./ModalMoveToFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports